import { LoadingButton } from "@mui/lab";
import { Box, Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FetchHook from "../../../../Api/FetchHooks";
import PostHooks from "../../../../Api/PostHooks";
import AlertComponent from "../../../../Components/AlertComponent";
import FormNumberInput from "../../../../Components/FormNumberInput";

const ApplyLoanForm = ({ user, onClose, onSuccess }) => {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [product, setProduct] = useState();
  const [productsOpt, setProducts] = useState();
  const [guarantorshipOpt, setGuarantorshipOpt] = useState([
    { label: "Self", value: "self" },
    { label: "Other members", value: "other_members" },
    { label: "Assets", value: "assets" },
    { label: "Pool fund", value: "pool_fund" },
  ]);
  const [guarantorship, setGuarantorship] = useState([]);

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [productsLoading, productsResponse, productsRequest] = FetchHook();
  const [applyLoading, applyResponse, applyRequest] = PostHooks();

  const fetchUserProduct = useCallback(async () => {
    try {
      const prodResp = await productsRequest({
        url: `/product?status='active'`,
      });
    } catch (error) {
      console.log("loan products err", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  }, [productsRequest]);

  useEffect(() => {
    fetchUserProduct();
  }, [fetchUserProduct]);

  useEffect(() => {
    if (
      productsResponse &&
      productsResponse.status === 200 &&
      productsResponse.data.StatusCode === 0
    ) {
      setProducts(productsResponse.data.Loan);
    } else if (
      productsResponse &&
      (productsResponse.status === 200 || productsResponse.status !== 200) &&
      productsResponse.data.StatusCode !== 0
    ) {
      const errorMessage =
        productsResponse?.data?.StatusMessage ??
        productsResponse?.data?.message ??
        productsResponse.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  }, [productsResponse]);

  console.log(product);

  const applyLoan = async (e) => {
    try {
      let formData = {
        product_id: product.id,
        entity_id: user.id,
        amount: e.amount,
        guarantor_type: JSON.stringify(guarantorship),
        description: "Loan application request recorded",
        repayment_count: e.repayment_count,
      };

      let props = {
        url: "loan_request",
        body: formData,
      };
      const loanReq = await applyRequest(props);

      if (loanReq && loanReq.status === 200 && loanReq.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Loan application successful!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          loanReq?.data?.StatusMessage ??
          loanReq?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(applyLoan)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl
        fullWidth
        sx={{
          mt: "5px",
        }}
      >
        <InputLabel id="product">Loan product</InputLabel>
        <Select
          labelId="product"
          id="product"
          defaultValue=""
          value={product}
          label="Loan product"
          onChange={(e) => setProduct(e.target.value)}
          required
        >
          {productsOpt &&
            productsOpt.map((product) => (
              <MenuItem value={product} key={product.id}>
                {product.loan_name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <Box sx={{ mt: 2 }}>
        <FormNumberInput
          name="amount"
          control={control}
          label={`Amount (max: ${product?.maximum_loan_amount} min: ${product?.minimum_loan_amount})`}
          min={product?.minimum_loan_amount}
          max={product?.maximum_loan_amount}
          rules={{
            required: "Please enter an amount!",
          }}
        />
      </Box>

      {/* <FormControl
        fullWidth
        sx={{
          mt: "20px",
        }}
        error={!!errors.upto_saving_percentage}
      >
        <InputLabel htmlFor="amount">
          Amount (max: {product?.maximum_loan_amount} min: {product?.minimum_loan_amount})
        </InputLabel>
        <OutlinedInput
          fullWidth
          id="amount"
          type="number"
          label={`Amount (max: ${product?.maximum_loan_amount} min: ${product?.minimum_loan_amount})`}
          {...register("amount")}
          onWheel={(event) => {
            event.target.blur();
          }}
          inputProps={{ step: "any" }}
        />
        {errors.amount && <FormHelperText>Enter loan amount!</FormHelperText>}
      </FormControl> */}

      <Box sx={{ mt: 2 }}>
        <FormNumberInput
          name="repayment_count"
          control={control}
          label={`Repayment period (max-months: ${product?.instalment_counts})`}
          max={product?.instalment_counts}
          rules={{
            required: "Please enter an amount!",
          }}
        />
      </Box>
      {/* 
      <FormControl
        fullWidth
        sx={{
          mt: "20px",
        }}
        error={!!errors.repayment_count}
      >
        <InputLabel htmlFor="amount">
          Repayment period (max: {product?.instalment_counts} min:{" "}
          {product?.minimum_instalment_count})
        </InputLabel>
        <InputLabel htmlFor="amount">
          Repayment period (max-months: {product?.instalment_counts})
        </InputLabel>
        <OutlinedInput
          fullWidth
          id="repayment_count"
          type="number"
          // label={`Repayment period (max: ${product?.instalment_counts} min:{" "}
          //   ${product?.minimum_instalment_count})`}
          label={`Repayment period (max-months: ${product?.instalment_counts})`}
          {...register("repayment_count")}
          onWheel={(event) => {
            event.target.blur();
          }}
          inputProps={{ step: "any" }}
        />
        {errors.repayment_count && (
          <FormHelperText>Enter loan repayment count!</FormHelperText>
        )}
      </FormControl> */}

      {product?.guarantorship === "YES" && (
        <FormControl
          fullWidth
          sx={{
            mt: "20px",
          }}
        >
          <InputLabel id="guarantorship">Guarantorship</InputLabel>
          <Select
            labelId="guarantorship"
            id="guarantorship"
            defaultValue=""
            multiple
            value={guarantorship}
            label="Guarantorship"
            onChange={(e) => {
              setGuarantorship(e.target.value);
            }}
            required={product?.guarantorship === "YES"}
          >
            {guarantorshipOpt.map((el, i) => (
              <MenuItem key={i} value={el.value}>
                {el.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" type="reset" onClick={() => onClose()}>
          Cancel
        </Button>
        <LoadingButton variant="contained" type="submit" loading={applyLoading}>
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default ApplyLoanForm;
